export default __webpack_public_path__ + "static/media/whiteLogo.f1e11ea8.svg";